import React, { useState, useRef, useEffect } from "react";

import { tranding_category_filter } from "../../data/categories_data";
import { HeadLine } from "../../components/component";
import Feature_collections_data from "../../data/Feature_collections_data";
import Collection_dropdown from "../../components/dropdown/collection_dropdown";
import Explore_collection_item from "../../components/collectrions/explore_collection_item";
import Meta from "../../components/Meta";
import { collectCollectionData } from "../../redux/counterSlice";
import { useDispatch, useSelector } from "react-redux";
import Image from "next/image";
import Collection_category_filter from "../../components/collectrions/collection_category_filter";
import {
  CampaignSvg,
  CountrySvg,
  ImpactCategorySvg,
  SuperCampaignSvg,
} from "../../components/svg/svgFilesGlobal";

import { campaignFilter, fetchGetAllNftPaginate } from "../../redux/apiSlice";
import Collection_dropdown2 from "../dropdown/collection_dropdown2";
import Link from "next/link";
import Likes from "../likes";
import Auctions_dropdown from "../dropdown/Auctions_dropdown";
export const baseURL = `${process.env.BASE_URL}/`;
const ExploreBrandToken = () => {
  const { campaignNft, isLoading } = useSelector((state) => state.api);
  const dispatch = useDispatch();
  const [priceRange, setPriceRange] = useState({
    min: 0,
    max: 0,
    status: "All",
  });
  const data_status = [
    {
      id: 0,
      text: "All",
      image: "/images/avatars/collection_ava_1.png",
    },
    {
      id: 1,
      text: "Available",
      image: "/images/avatars/collection_ava_1.png",
    },
    {
      id: 2,
      text: "Sold",
      image: "/images/avatars/collection_ava_1.png",
    },
  ];
  useEffect(() => {
    dispatch(campaignFilter(priceRange));
  }, [priceRange, dispatch]);
  useEffect(() => {
    const fetchData = () => {
      try {
        dispatch(
          fetchGetAllNftPaginate({
            id: "63c42a6b4df378abfe55cd84",
            offset: 0,
            isSold: false,
            All: false,
          }),
        );
      } catch (error) {
        console.error("API request failed:", data.error);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <>
      <section className="relative lg:pb-48 pb-24">
        <div className="container">
          {/* <p>Impact Filters</p> */}
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/3 p-4">
              <div className="relative">
                <div>
                  {/* filter-Icon.svg */}
                  <label className="ml-1 font-display text-jacarta-700 mb-2 block dark:text-white">
                    Filter Impact Art
                  </label>
                </div>

                {/* dropdown */}
                <div className="dropdown my-1 cursor-pointer">
                  <Collection_dropdown2
                    setPriceRange={setPriceRange}
                    priceRange={priceRange}
                    data={data_status}
                    collection={true}
                  />
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/3 p-4">
              <div className="relative">
                <div>
                  <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                    Min Price
                  </label>
                  <input
                    type="number"
                    id="item-name"
                    className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                    placeholder="Min Price"
                    required
                    disabled={priceRange.status == "All" ? "disabled" : ""}
                    onChange={(e) =>
                      setPriceRange({ ...priceRange, min: e.target.value })
                    }
                  />
                </div>

                {/* dropdown */}
                <div className="dropdown my-1 cursor-pointer"></div>
              </div>
            </div>
            <div className="w-full md:w-1/3 p-4">
              <div className="relative">
                <div>
                  <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                    Max Price
                  </label>
                  <input
                    type="text"
                    id="item-name"
                    className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                    placeholder="Max Price"
                    required
                    disabled={priceRange.status == "All" ? "disabled" : ""}
                    onChange={(e) =>
                      setPriceRange({ ...priceRange, max: e.target.value })
                    }
                  />
                </div>

                {/* dropdown */}
                <div className="dropdown my-1 cursor-pointer"></div>
              </div>
            </div>
          </div>
          {/* <!-- Filter --> */}

          {/* <!-- Grid --> */}

          <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-2 lg:grid-cols-4">
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              campaignNft?.campaigns?.map((item, index) => {
                return (
                  <article key={index}>
                    <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                      <figure className="relative">
                        <Link href={`/marketplace/${item._id}`}>
                          <Image
                            width={230}
                            height={230}
                            src={baseURL + item.imageUrl}
                            alt="item 5"
                            className="w-full h-[230px] rounded-[0.625rem] object-cover"
                          />
                        </Link>
                        <div
                          onClick={() => {
                            addToFav(item._id).then((res) => {
                              successToast(res.data.message);
                            });
                          }}
                        >
                          <Likes like="15" />
                        </div>

                        {/* <div className="absolute left-3 -bottom-3">
                    <div className="flex -space-x-2">
                      <Link href={`/404`}>
                        <Tippy content={<span>creator: Sussygirl</span>}>
                          <Image
                            width={21}
                            height={21}
                            src="/images/avatars/creator_1.png"
                            alt="creator"
                            className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                          />
                        </Tippy>
                      </Link>
                      <Link href={`/404`}>
                        <Tippy content={<span>creator: Sussygirl</span>}>
                          <Image
                            width={21}
                            height={21}
                            src="/images/avatars/owner_1.png"
                            alt="owner"
                            className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                          />
                        </Tippy>
                      </Link>
                    </div>
                  </div> */}
                      </figure>
                      <div className="mt-7 flex items-center justify-between">
                        <Link href={`/marketplace/${item._id}`}>
                          <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                            {item.itemName}
                          </span>
                        </Link>

                        <Auctions_dropdown
                          share_to={`/marketplace/${item._id}`}
                          classes="dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full "
                        />
                      </div>

                      <div className="mt-2 text-sm">
                        <span className="dark:text-jacarta-200 text-jacarta-700 mr-1">
                          Creator: {item.creator.username}
                        </span>
                      </div>
                      <div className="mt-2 text-sm">
                        <span className="dark:text-jacarta-200 text-jacarta-700 mr-1">
                          Price: ${item.priceUsd}
                        </span>
                      </div>
                      <div className="flex items-center justify-center">
                        {/* The real checkout lives on the detail page — the
                            old buy modal was an empty shell with no purchase
                            action. */}
                        <Link
                          href={`/marketplace/${item._id}`}
                          className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all mt-4 inline-block"
                        >
                          BUY NOW
                        </Link>
                      </div>
                    </div>
                  </article>
                );
              })
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default ExploreBrandToken;
